import React from "react";
import { useSelector } from "react-redux";
import ProductCards from "../ProductCards/index";
import { RafflesContainer } from "./styles";

const Raffles = (props) => {
const { rafflesVersions, rafflesWinnersData } = useSelector((state) => state.raffles);
  
  return (
    <>
      {rafflesVersions?.length > 0 && (
        <RafflesContainer>
          <ProductCards
            title={`${rafflesVersions?.length || 0} Sorteios`}
            subtitle="Você pode ser um dos premiados!"
            rafflesVersions={rafflesVersions}
            data={rafflesWinnersData || []}
            disclaimer="As imagens dos prêmios são meramente ilustrativas."
            onChangeTab={props.onChangeTab}
          />
        </RafflesContainer>
      )}
    </>
  );
};

export default Raffles;
